document.addEventListener("DOMContentLoaded", function () {
  const goUpButton = document.querySelector(".go-up");

  if (goUpButton) {
    goUpButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default anchor behavior
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
});
